/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-12 09:11:18
 * @LastEditTime: 2019-09-23 13:45:38
 * @LastEditors: Please set LastEditors
 */

// 新接口
import axios from 'axios'
import Encode from './encode'
import store from './../../store'
import { toLoginByAppOrH5 } from './../../utils/loginByAppOrH5'

axios.interceptors.response.use(res => {
  return res
}, err => {
  return Promise.reject(err.response)
  // if (err.response.status == 401) {
  //     let encodeStr = Encode.encodeFunc('login_main')
  //     let obj = {
  //         url: "https://tool.yxj.org.cn/app/" + encodeStr.data
  //     }
  //     goPage(obj, (token) => {
  //         console.log(token, 'token');
  //         localStorage.setItem("token", token);
  //         store.commit("editLoginStatus");
  //     });
  // }
})

export const api = function (url, body, method, platform, buriedPointReset, otherParams) {
  console.log(localStorage.getItem('token'), body, '这是请求--------------')
  const CancelToken = axios.CancelToken
  const data = {
    // 'brand': '',
    // 'guid': store.state.user.guid ? store.state.user.guid : window.uuid, // 必传
    // 'model': '',
    // 'platform': store.state.platform || 'WeChat',
    // 'sysVersion': '',
    // 'time': parseInt(+new Date() / 1000),
    // 'uid': store.state.user.uid ? store.state.user.uid : -1, // 必传
    // 'version': store.state.user.version ? store.state.user.version : '5.9.0', // 必传
    // 'session': store.state.user.session ? store.state.user.session : '',
    // 'body': body
  }
  if (buriedPointReset) {
    data.buriedPointReset = {}
    if (buriedPointReset.isMain) {
      data.buriedPointReset.isMain = buriedPointReset.isMain
    }
    if (buriedPointReset.searchSource) {
      data.buriedPointReset.searchSource = Number(buriedPointReset.searchSource)
    }
  }
  // console.log(`%c 请求：${url}`, 'color: blue;font-size: 16px', data)
  // console.log(`%c 请求：${url}`, 'color: blue;font-size: 16px', body)
  // let sendData = Encode.encodeFunc(data)
  // let sendData = data
  return new Promise((resolve, reject) => {
    axios({
      method: method || 'post',
      url: window.API_ROOT + url,
      params: method == 'get' ? body : '',
      data: body,
      headers: {
        'token': localStorage.getItem('token') ? localStorage.getItem('token') : ''
      },
      // `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
      // 如果请求话费了超过 `timeout` 的时间，请求将被中断
      timeout: (otherParams && otherParams.timeout) ? otherParams.timeout : 0,
      cancelToken: new CancelToken(function executor (cancel) {
        // 2.将cancel token存入列表
        if (url === 'content/searchDrugUnion' || url === 'content/searchDrugTaboo') {
          window.axiosPromiseArr.push({ cancel })
          console.log(window.axiosPromiseArr)
        }
      })
    })
      .then((res) => {
        console.log(res, '响应结果===========')
        if (res.data.code == 401) {
          let a = Encode.encodeFunc('login_main')
          console.log('https://tool.yxj.org.cn/app/' + a.data)
          let obj = {
            url: 'https://tool.yxj.org.cn/app/' + a.data
          }
          goPage(obj, (token) => {
            localStorage.setItem('token', token)
            store.commit('editLoginStatus')
          })
          return
        }
        let getData = res.data
        let decodeGetData = getData
        // let decodeGetData = JSON.parse(Encode.decodeFuc(getData.data)) // 解密data   获取的是字符串
        // let toAes = Encode.encodeFunc(decodeGetData) // 对解密的数据加密
        console.log(`%c 响应：${url}`, 'color: green;font-size:16px;', decodeGetData)
        if (decodeGetData.code === 200) {
          resolve(decodeGetData.body || decodeGetData)
        } else if (decodeGetData.code === 999) {
          toLoginByAppOrH5()
          resolve(decodeGetData.body)
        } else if ((decodeGetData.code == 607 || decodeGetData.code == 610) && url === 'user/registerLogin') {
          resolve(decodeGetData.body)
        } else {
          const timeError = {
            msg: decodeGetData.msg,
            data: decodeGetData,
            code: decodeGetData.code
          }
          reject(timeError)
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('请求取消')
        } else {
          // let error = {
          //     msg: '服务器开小差啦'
          // }
          console.debug(err)
          reject(err)
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/server/api/api.js